import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';

import { freemiumApi } from '@client/api/waterlily';

// Drives the BGA eligibility dialog: collects the advisor's BGA name, emails it
// to the team, then closes shortly after showing the confirmation.
export function useBgaInquiry(advisorId: string | undefined) {
  const [open, setOpen] = useState(false);
  const [bgaName, setBgaName] = useState('');

  const mutation = useMutation({
    mutationFn: (name: string) => {
      if (!advisorId) throw new Error('Missing advisor');
      return freemiumApi.postBgaInquiry(advisorId, { bgaName: name.trim() });
    },
  });

  useEffect(() => {
    if (!mutation.isSuccess) return;
    const timer = setTimeout(() => setOpen(false), 1800);
    return () => clearTimeout(timer);
  }, [mutation.isSuccess]);

  useEffect(() => {
    if (open) return;
    setBgaName('');
    mutation.reset();
  }, [open]);

  return {
    open,
    setOpen,
    bgaName,
    setBgaName,
    submit: () => mutation.mutate(bgaName),
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    canSubmit: bgaName.trim().length > 0 && !mutation.isPending && !!advisorId,
  };
}
